<template>
  <b-modal ref="technicalDevice-card-modal" @ok="technicalDeviceCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.azk.technicalDevices.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.technicalDevices.tableColumns.nameTechnicalDevice"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="nameTechnicalDevice"
          :state="isNameValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.technicalDevices.tableColumns.registerNumber"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="registerNumber"
          :state="isRegisterNumberValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.technicalDevices.tableColumns.brand"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="brand"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.technicalDevices.tableColumns.typeVehicle"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="typeId"
          :options="typeOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.technicalDevices.tableColumns.volumeFuelTank"
        label-for="input-horizontal"
      >
        <b-form-input
          type="number"
          min="1"
          max="1000"
          v-model="volumeFuelTank"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.fuelDepo"
        label-for="input-horizontal"
      >
        <b-form-select
          v-model="fuelDepoId"
          :state="isFuelDepoValid"
          :options="fuelDepoOptions"
          style="font-size: 13px"
        ></b-form-select>
      </b-form-group>

    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>

import { azkService } from "../../../../services";

export default {
  name: "CreateTechnicalDevicePage",
  props: {
    fuelDepos: Array,
    technicalDevices: Array,
  },
  components: {},
  data() {
    return {
      fuelDepoOptions: [],
      nameTechnicalDevice: null,
      registerNumber: null,
      brand: null,
      typeId: null,
      volumeFuelTank: null,
      fuelDepoId: null,
     
      isNameValid: null,
      isRegisterNumberValid: null,
      isFuelDepoValid: null
    };
  },
  computed: {
    typeOptions() {
      const typeOptions = [];

      for (
        let i = 0;
        i <
        this.$store.state.localization.data.mainPage.azk.technicalDevices.typeOptions
          .length;
        i++
      ) {
        typeOptions.push({
          value:
            this.$store.state.localization.data.mainPage.azk.technicalDevices
              .typeOptions[i].key,
          text: this.$store.state.localization.data.mainPage.azk.technicalDevices
            .typeOptions[i].value,
        });
      }
      return typeOptions;
    },
  },
  methods: {
    open() {
      this.nameTechnicalDevice = null;
      this.registerNumber = null;
      this.brand = null;
      this.typeId = 0;
      this.volumeFuelTank = null;
      this.fuelDepoId = null;
      
      this.isNameValid = null;
      this.isRegisterNumberValid = null;
      this.isFuelDepoValid = null;
      this.fuelDepoOptions = [];

      for (let i = 0; i < this.fuelDepos.length; i++) {
        this.fuelDepoOptions.push({
          value: this.fuelDepos[i].id,
          text: this.fuelDepos[i].name,
        });
      }

      this.$refs["technicalDevice-card-modal"].show();
    },
    validate() {
      let isValid = true;

      if (!this.nameTechnicalDevice) {
        this.isNameValid = false;
        isValid = false;
      } else {
        this.isNameValid = null;
      }

      if (!this.registerNumber) {
        this.isRegisterNumberValid = false;
        isValid = false;
      } else {
        this.isRegisterNumberValid = null;
      }

      if (!this.fuelDepoId) {
        this.isFuelDepoValid = false;
        isValid = false;
      } else {
        this.isFuelDepoValid = null;
      }

      return isValid;
    },
    async technicalDeviceCardModalOk(event) {
      if (!this.validate()) {
        event.preventDefault();
        return;
      }

      const fuelDepoId = parseInt(this.fuelDepoId);
      const technicalDevice = this.technicalDevices.find(x => x.fuelDepoId == fuelDepoId);

      const technicalDeviceCard = {
        nameTechnicalDevice: this.nameTechnicalDevice,
        registerNumber: this.registerNumber,
        brand: this.brand,
        typeVehicle: parseInt(this.typeId),
        volumeFuelTank: this.volumeFuelTank,
        clientId: technicalDevice.clientId,
        fuelDepoId: fuelDepoId
      };

      const createTechnicalDeviceResponse = await azkService.createTechnicalDevice(technicalDeviceCard);

      if (
        createTechnicalDeviceResponse.isSuccess &&
        createTechnicalDeviceResponse.data &&
        createTechnicalDeviceResponse.data.countInsertedRows == 1
      ) {
        this.$emit("technicalDeviceCreatedSuccessEvent", this.technicalDevice);
      } else {
        this.$emit("technicalDeviceCreatedFailEvent");
      }
    },
  },
};
</script>
